module.exports = __webpack_public_path__ + "media/src/images/icons/checkmark-3e749183c9d1cf9358fb0a098b63dc10.svg";